import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";
import Card from "../../../components/card/card";
import { useContext, useEffect, useMemo } from "react";
import { ClientCardWrapper } from "./client-details.styles";
import Skeleton from "../../../../../components/skeleton/skeleton";
import useFetchUserDetails from "../../../../../hooks/useFetchUserDetails";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import OverflowText from "../../../../../components/overflow-text/overflow-text";
import EditIcon from "@mui/icons-material/Edit";

const Clients = () => {
  const {
    state: { selectedClientAccount, user, activeStep, clientsList },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { watch } = useFormContext();
  const formValues = watch();

  const { emailUsers, phoneUsers, fetchDetailsByEmail, fetchDetailsByPhone } =
    useFetchUserDetails();

  const userDetails = useMemo(
    () => {
      if (clientsList && clientsList.length > 0) {
        return clientsList;
      }
      return [...emailUsers, ...phoneUsers]?.reduce((acc, user) => {
        if (!acc.some((existingUser: any) => existingUser.id === user.id)) {
          acc.push(user);
        }
        return acc;
      }, []);
    }, [clientsList, emailUsers, phoneUsers]
  );

  const handleEditClick = (client: any) => {
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_USER,
      payload: client,
    });
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.UPDATE_USER_META,
      payload: true,
    });
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
      payload: 9,
    });
  };

  useEffect(() => {
    if ((!clientsList || clientsList.length === 0)) {
      if (user?.email || formValues?.email)
        fetchDetailsByEmail(user?.email || formValues?.email);
      if (user?.phone || formValues?.mobile)
        fetchDetailsByPhone(user?.phone || formValues?.mobile);
    }
  }, [
    fetchDetailsByEmail,
    fetchDetailsByPhone,
    formValues?.email,
    formValues?.mobile,
    user?.email,
    user?.phone,
    clientsList,
  ]);

  return (
    <Card
      title={"Choose account"}
      description={
        "We found two accounts registered with your email address or your phone number. Please select one to continue"
      }
      btnTitle={"Continue"}
      onHandleClick={() => {
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep + 1,
        });
      }}
      progress={activeStep * 5}
      disabledConfirmBtn={!selectedClientAccount?.id}
    >
      <>
        {userDetails.length === 0 &&
          [...Array(3)].map((_, index) => (
            <Skeleton key={index} height={100} />
          ))}
        {userDetails.map((user: any) => (
          <ClientCardWrapper
            key={user.id}
            className={selectedClientAccount?.id === user.id ? "opened" : ""}
            onClick={() => {
              userDispatcher({
                type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT,
                payload: user,
              });
            }}
          >
            <Box
              sx={{
                marginLeft: "auto",
                cursor: "pointer",
                position: "absolute",
                right: "20px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(user);
              }}
            >
              <EditIcon fontSize="small" htmlColor="gray" />
            </Box>
            <Box className="row">
              <Box>
                <Box className="label">ID</Box>
                <Box className="value">{user.id}</Box>
              </Box>
              <Box>
                <Box className="label">Name</Box>
                <Box className="value">
                  {user.first_name} {user?.last_name}
                </Box>
              </Box>
              <Box>
                <Box className="label">Email</Box>
                <Box className="value">{user.email || "--"} </Box>
              </Box>
            </Box>
            <Box className="row2">
              <Box>
                <Box className="label">Phone Number</Box>
                <Box className="value">
                  +{user.mobile[0]}
                  {user.mobile.slice(1)}
                </Box>
              </Box>
              <Box>
                <Box className="label">Address</Box>
                <Box
                  className="value"
                >{`${user.address},${user.city},${user.state}`}</Box>
              </Box>
            </Box>
          </ClientCardWrapper>
        ))}
      </>
    </Card>
  );
};

export default Clients;
